<template>
  <div style="height:100%" class="d-flex justify-center align-center">

    <div class="d-flex flex-column" style="width:509px">
      <img style="width:100%;" src="/img/logo-500x164.png">
      <!-- <img style="margin: 10px 16px 0 0; width: 61%; align-self:end;" src="/img/backoffice.png"> -->
      <div class="_backoffice_logo _backoffice_logo_big">BACKOFFICE</div>
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
}
</script>